// import axios from '../plugins/axios'
import axios from 'axios'
// const URL = 'http://localhost:5000';
//axios.defaults.headers.common['token'] = 'value' 
//call HID from localstorage

export default class hidServices {

  async getBorangByHID(HID, tahunKutipan) {
    try {
      const res = await axios.get(`${process.env.VUE_APP_API_URL}/public/getBorangByHID?HID=` + HID + "&tahun="+tahunKutipan, {
      })
      //console.log(res.data.data)
      return res;
    } catch (error) {
      return error;
    }
  }

  async logmskresponden(HID, notac) {
    try {
      await axios.post(`${process.env.VUE_APP_API_URL}/public/logmasukresponden?`, {
        HID:HID,
        HIESID:notac
      }).then(result=>{
        console.log(result.data)
        return [
          {data:'logmskresponden'}
        ]
      })
    } catch (err) {
      console.log(err)
    }
  }
}